import { render, staticRenderFns } from "./Tournaments.vue?vue&type=template&id=950883a8&scoped=true&"
import script from "./Tournaments.vue?vue&type=script&lang=ts&"
export * from "./Tournaments.vue?vue&type=script&lang=ts&"
import style0 from "./Tournaments.vue?vue&type=style&index=0&id=950883a8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "950883a8",
  null
  
)

export default component.exports